import useShippingBoConnectionRedirect from "@babackapp/private-api-client/client/use-shipping-bo-integration-connection-redirect";
import useShippingBoDisconnect from "@babackapp/private-api-client/client/use-shipping-bo-integration-disconnect";
import useTranslation from "@babackapp/translations/use-translation";
import { Button } from "@babackapp/ui/components/button";
import { CheckCircleIcon } from "lucide-react";
import { useCurrentShopSuspense } from "@/api/shops/use-current-shop-suspense";
import IntegrationPreview from "./integration-preview";
import {useListShippingboHooks} from "@babackapp/private-api-client/client/use-list-shippingbo-hooks";
import {useResetShippingboHooks} from "@babackapp/private-api-client/client/use-reset-shippingbo-hooks";

function ShippingBoIntegration() {
	const t = useTranslation();

	const { data: shop } = useCurrentShopSuspense();
	const isConnected = !!shop.integrations.shippingBo.accessToken;
	const connectRedirect = useShippingBoConnectionRedirect(shop);
    const installedHooks = useListShippingboHooks({shopId: shop.id, enabled: !!shop.integrations.shippingBo.accessToken});
    const resetHooks = useResetShippingboHooks(shop);
	const disconnect = useShippingBoDisconnect(shop);

	if (!isConnected) {
		return (
			<Button onClick={() => connectRedirect.mutateAsync()}>
				{t("settings.integrations.thirdpart.shippingBo.connect")}
			</Button>
		);
	}

	return (
		<>
			<div className="rounded-md bg-green-50 p-4 w-full">
				<div className="flex">
					<div className="flex-shrink-0">
						<CheckCircleIcon
							className="h-5 w-5 text-green-400"
							aria-hidden="true"
						/>
					</div>
					<div className="ml-3">
						<h3 className="text-sm font-medium text-green-800">
							{t(
								"settings.integrations.thirdpart.shippingBo.integrationCompleted",
							)}
						</h3>
						<div className="mt-2 text-sm text-green-700">
							<p>
								{t("settings.integrations.thirdpart.shippingBo.successMessage")}
							</p>
						</div>
					</div>
				</div>
			</div>
            {installedHooks.isFetched ?
            installedHooks?.data?.map(item => {
                return (
                    <div key={item.id} className="flex flex-col p-2 border rounded text-sm break-all">
                        <p>Id: {item.id}</p>
                        <p>Event: {item.object_class}</p>
                        <p>URL: {item.endpoint_url}</p>
                    </div>
                )
            }) : null}

            {/* Disconnect button */}
			<div className="flex justify-between">
              <Button
                variant="destructive"
                size="sm"
                onClick={() => resetHooks.mutateAsync()}
              >
                {t("misc.refresh")}
              </Button>
				<Button
					variant="destructive"
					size="sm"
					onClick={() => disconnect.mutateAsync()}
				>
					{t("misc.disconnect")}
				</Button>
			</div>
		</>
	);
}

export function ShippingBoIntegrationPreview() {
	const t = useTranslation();
	const { data: shop } = useCurrentShopSuspense();

	if (!shop || !shop.plan.shippingBo) return null;

	return (
		<IntegrationPreview
			title="ShippingBo"
			description={t("settings.integrations.thirdpart.shippingBo.description")}
			logo="/integrations/shippingbo.png"
			seeMoreUrl="https://shippingbo.com/"
            onActivationUpdate={() => {}}
            activated={shop.integrations.shippingBo.activated}
		>
			<ShippingBoIntegration />
		</IntegrationPreview>
	);
}
